// extracted by mini-css-extract-plugin
export var root = "MarkdownStrong-module--root--fab94";